'use client';
import React from 'react';

import { Lottie } from '@whelk/components';
import darkLottie from './json/home-smile.json';

export const SmileLottie = () => {
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '24px' }}
      data={darkLottie}
      loop={true}
      play={true}
    />
  );
};
